import { createRouter, createWebHistory } from "vue-router";
import allTools from "../components/CalcAll.vue";
import toolOne from "../components/CalcOne.vue";
import toolTwo from "../components/CalcTwo.vue";
import toolThree from "../components/CalcThree.vue";
import toolFour from "../components/CalcFour.vue";
import HomeView from "../views/HomeView.vue";
const routes = [
	{
		// Catch incorrect routes
		path: "/:catchAll(.*)",
		redirect: "/",
	},
	{
		path: "/",
		components: {
			default: HomeView,
			allTools,
			toolOne,
			toolTwo,
			toolThree,
			toolFour,
		},
		meta: { hiddenForDemo: true },
	},
	{
		path: window.location.pathname,
		name: "hollow-fiber-calculators",
		component: allTools,
	},
	{ path: "/tool-1", name: "tool-1", component: toolOne },
	{
		path: "/tool-2",
		name: "tool-2",
		component: toolTwo,
	},
	{
		path: "/tool-3",
		name: "tool-3",
		component: toolThree,
	},
	{
		path: "/tool-4",
		name: "tool-4",
		component: toolFour,
	},
];

// Base URL
let base = process.env.BASE_URL || "/";
const router = createRouter({
	history: createWebHistory(base),
	base: base,
	routes,
});

router.beforeEach((to, from, next) => {
	const hiddenForDemo = to.matched.some(
		(record) => record.meta.hiddenForDemo
	);
	if (hiddenForDemo && process.env.VUE_APP_SHOW_CALC == "all") {
		next({
			name: "hollow-fiber-calculators",
		});
	} else {
		next();
	}
});
export default router;
